import module from '../module';
import * as _ from 'lodash';

class OrderHistoryDetailsDirectiveController {
    static $inject = [ '$scope', 'OrderHistoryService', 'CartGroupsService' ];

    constructor(scope, orderHistoryService, cartGroupsService) {
        this._scope = scope;
        this._orderHistoryService = orderHistoryService;
        this._cartGroupsService = cartGroupsService;
        scope.printDetails = () => this._printDetails();
        scope.groups = [];
        this._getItems();
    }

    async _getItems() {
        const details = await this._orderHistoryService.getDetails(this._scope.orderDetails.orderId);
        this._scope.groups = await this._cartGroupsService.groupItems(details.items, details.participants);
        _.each(this._scope.groups, group => {
            group.history = true;
            group.editable = false;
        });
    }

    _printDetails() {
        window.print();
    }
}

module.directive('orderHistoryDetails', function () {
    return {
        templateUrl: 'modules/profile/views/orderHistoryDetails.html',
        controller: OrderHistoryDetailsDirectiveController
    };
});



// WEBPACK FOOTER //
// ./src/modules/profile/directives/OrderHistoryDetailsDirective.js